import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { RangerSelectorComponent } from 'src/app/shared/ui/atoms/ranger-selector/ranger-selector.component';
import { AmountInputComponent } from 'src/app/shared/ui/atoms/amount-input/amount-input.component';
import { UiSelectAtomComponent, UiSelectOption } from 'src/app/shared/ui/atoms/ui-select/ui-select.component';
import { FilterOptionGroupComponent } from 'src/app/shared/ui/molecules/filter-option-group/filter-option-group.component';

export type DynamicFilterType = 'range' | 'select' | 'check' | 'bool' | 'text';

// Forma mínima que necesita este dispatcher; OfferService sigue manejando 'filtersSel: any[]'.
export interface DynamicFilterDescriptor {
  id: number;
  type: DynamicFilterType;
  description?: string;
  min?: number;
  max?: number;
  medida?: string;
  options?: Array<string | boolean>;
}

export interface DynamicFilterValueChange {
  id: number;
  value: number | string;
}

@Component({
  selector: 'app-dynamic-filter-field',
  imports: [
    RangerSelectorComponent,
    AmountInputComponent,
    UiSelectAtomComponent,
    FilterOptionGroupComponent,
  ],
  template: `
    <div class="dynamic-filter-field"
        [class.dynamic-filter-field--bool]="filter().type === 'bool'">
      <p class="dynamic-filter-field__label">{{ filter().description }}</p>
      @switch (filter().type) {
        @case ('range') {
          <app-ranger-selector
            [rangeId]="'range_' + filter().id"
            [min]="filter().min ?? 0"
            [max]="filter().max ?? 100"
            [initialValue]="filter().min ?? 0"
            [medida]="filter().medida ?? ''"
            [resetKey]="resetKey()"
            (valueChange)="emitChange($event)" />
        }
        @case ('select') {
          <app-ui-select
            [selectId]="'sc' + filter().id"
            [options]="selectOptions()"
            placeholder=" Elige lo que necesites "
            [resetKey]="resetKey()"
            (selectionChange)="handleSelectChange($event)" />
        }
        @case ('check') {
          <app-filter-option-group
            [options]="filter().options ?? []"
            mode="check"
            [resetKey]="resetKey()"
            (optionSelected)="emitChange($event)" />
        }
        @case ('bool') {
          <app-filter-option-group
            [options]="filter().options ?? []"
            mode="bool"
            [resetKey]="resetKey()"
            (optionSelected)="emitChange($event)" />
        }
        @case ('text') {
          <app-amount-input [resetKey]="resetKey()" (valueChange)="emitChange($event)" />
        }
      }
    </div>
  `,
  styleUrl: './dynamic-filter-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFilterFieldComponent {
  readonly filter = input.required<DynamicFilterDescriptor>();
  // Se propaga a los controles para que 'Limpiar filtros' los devuelva a su valor inicial.
  readonly resetKey = input(0);

  readonly valueChange = output<DynamicFilterValueChange>();

  readonly selectOptions = computed<UiSelectOption[]>(() =>
    (this.filter().options ?? []).map(opt => ({ value: String(opt), label: String(opt) }))
  );

  emitChange(value: number | string): void {
    this.valueChange.emit({ id: this.filter().id, value });
  }

  handleSelectChange(event: Event): void {
    this.emitChange((event.target as HTMLSelectElement).value);
  }
}
